module.exports = __webpack_public_path__ + "static/sys_ph02-358a2ebe602a9045d598e9fbd6faf381.jpg";